import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';

import { AuthLogoutService } from '../../service/auth-logout/auth-logout.service';
import { OwnerService, Owner } from '../../service/owner/owner.service';
import { CommonService } from '../../service/common/common.service';
import { DialogsService } from '../../../component/dialog/dialogs.service';
import { environment } from '../../../environments/environment';
import { config } from '../../util/config';
import { isAuthority } from '../../util/util';

export let isSingleOwner:boolean;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() title: string;
  @Input() leftnav;
  @Input() showNavbar = true;
  @Input() displayedOwner = false;
  @Input() isShowOwnerSelect = false;
  @Input() showCommonHeader = false;
  @Input() showOwnerLinkedUserHeader = false;
  @Input() showHumburgerMenu = false;
  @Output() onChange = new EventEmitter<any>();
  @ViewChild('inputOwnerdisplayTx') inputOwnerdisplayTx;
  @ViewChild('ownerForm') ownerForm: ElementRef;

  @Output() onInputChanged = new EventEmitter<any>();

  public backgroundColor: string;
  public devHeaderCls: string;
  public devEnv: string;
  public production = environment.production;
  public user: object;
  public version: string;
  public working = false;
  private local = environment.local;

  public owners: any;
  public ownerdisplayTx = new FormControl();
  public filteredOwnerOptions: Observable<string[]>;
  public ownerShow = false;
  public ownerSelect = false;

  public isLogin = false;

  public isAuthorityWa9001 = isAuthority('wa9001');
  private systemerr = null;
  private isShowHeaderAutoloader = false;
  private isChooseOwner = false;

  public isOperatorUser = false
  private showOwnerResetButton:string;

  private isOwnerlinkedUser = null;

  public owner: Owner;

  /**
   * usage: sessionStorage.setItem('isOwnerDisable', 'true');
   */
  private isOwnerDisable = false;

  readonly STRINGS_IS_SHOW_OWNER_SELECT = 'isShowOwnerSelect';
  readonly STRINGS_IS_OWNER_DISABLE = 'isOwnerDisable';
  constructor(
    private router: Router,
    private authLogoutService: AuthLogoutService,
    private dialogsService: DialogsService,
    private commonService: CommonService,
    private ownerService: OwnerService
  ) {
    if (this.production) {
      this.backgroundColor = 'primary';
      this.devHeaderCls = '';
    } else {
      this.backgroundColor = 'warn';
      this.devHeaderCls = 'devHeader';
      if (this.local) {
        this.devEnv = 'Local Development';
      } else {
        this.devEnv = 'Development';
      }
    }
    this.version = environment.version;
    this.user = {
      userTx: ''
    };
  }

  ngOnInit() {
    this.verifyLogin();
    this.verifyOwner();
    if (this.showNavbar === true) {
      if (this.isLogin === true) {
        this.ownerService
          .get()
          .then(outputJson => {
            this.owners = outputJson.owners;
            
            this.setSingleOwner(this.owners);
            if(!isSingleOwner) {
              this.owners.unshift({
                ownerdisplayTx: 'ALL',
                ownerId: ''
              });
            }
            this.filteredOwnerOptions = this.ownerdisplayTx.valueChanges.startWith(null).map(val => (this.ownerfilter2(val)));

            this.setLinkedowner();

          })
          .catch(error => {
            this.systemerr = this.commonService.getErrorMessage(error);
            this.logout();
          });
      } else {
        console.log('header.ngOnInit retry');
        // 新規タブでURLを直接指定して開いた場合、sessionStorageから値を取得できないことがあるので、待機してから再実行
        // app.componentのsessionStorage_transferにて、sessionStorageの準備ができていないと思われる
        setTimeout(() => {
          if (this.isLogin === true) {
            this.ownerService
              .get()
              .then(outputJson => {
                this.owners = outputJson.owners;
                this.owners.unshift({
                  ownerdisplayTx: 'ALL',
                  ownerId: ''
                });
                this.filteredOwnerOptions = this.ownerdisplayTx.valueChanges.startWith(null).map(val => (this.ownerfilter2(val)));

                this.setLinkedowner();
              })
              .catch(error => {
                this.systemerr = this.commonService.getErrorMessage(error);
                this.logout();
              });
          }
        }, config.waitMsForSessionInHeaderNgOnInit);
      }
    }
  }

  ownerfilter(val: string): string[] {
    return this.owners.filter(owner => owner.ownerdisplayTx.indexOf(val) !== -1);
  }

  ownerfilter2(val: string): string[] {

    if (val != null && val.length > 0) {
      return this.ownerfilter(val);
    }
    return this.owners;
  }

  ownerfilter3(val: string): string[] {
    return this.owners.filter(owner => owner.ownerdisplayTx === val);
  }

  verifyOwner() {

    const loginResult = JSON.parse(sessionStorage.getItem('loginResult'));
    const ownerResult = sessionStorage.getItem('ownerResult');

    if (loginResult.user.roleId == '3' && loginResult.user.linkedownerId == null) {
      this.systemerr = '荷主との紐づけがされていない荷主ユーザです。';
      this.logout();
    } else if (ownerResult !== null) {
      const selectedOwner = JSON.parse(ownerResult);
      this.ownerdisplayTx.setValue(selectedOwner.ownerdisplayTx);
    } else {
      console.log('header.verifyOwner false1');
      // 新規タブでURLを直接指定して開いた場合、sessionStorageから値を取得できないことがあるので、待機してから再実行
      // app.componentのsessionStorage_transferにて、sessionStorageの準備ができていないと思われる
      setTimeout(() => {

        const loginResult = JSON.parse(sessionStorage.getItem('loginResult'));
        const ownerResult = sessionStorage.getItem('ownerResult');

        if (loginResult.user.roleId == '3' && loginResult.user.linkedownerId == null) {
          this.systemerr = '荷主との紐づけがされていない荷主ユーザです。';
          this.logout();
        } else if (ownerResult !== null) {
          const selectedOwner = JSON.parse(ownerResult);
          this.ownerdisplayTx.setValue(selectedOwner.ownerdisplayTx);
        } else {
          console.log('header.verifyOwner false2');
        }
      }, config.waitMsForSessionInHeaderVerifyOwner);
    }
  }

  verifyLogin() {
    const result = sessionStorage.getItem('loginResult');
    if (result !== null) {
      const resultObject = JSON.parse(result);
      this.user = resultObject.user;
      this.isLogin = true;

      if (sessionStorage.getItem(this.STRINGS_IS_SHOW_OWNER_SELECT) == null) sessionStorage.setItem(this.STRINGS_IS_SHOW_OWNER_SELECT, 'true');
    } else {
      console.log('header.verifyLogin false1');
      // 新規タブでURLを直接指定して開いた場合、sessionStorageから値を取得できないことがあるので、待機してから再実行
      // app.componentのsessionStorage_transferにて、sessionStorageの準備ができていないと思われる
      setTimeout(() => {
        const result = sessionStorage.getItem('loginResult');
        if (result !== null) {
          const resultObject = JSON.parse(result);
          this.user = resultObject.user;
          this.isLogin = true;
          if (sessionStorage.getItem(this.STRINGS_IS_SHOW_OWNER_SELECT) == null) sessionStorage.setItem(this.STRINGS_IS_SHOW_OWNER_SELECT, 'true');
        } else {
          sessionStorage.clear();
          this.isLogin = false;
          console.log('header.verifyLogin false2');
          this.router.navigate(['wa0001']);
        }
      }, config.waitMsForSessionInHeaderVerifyLogin);
    }
  }

  saveOwner(event: string) {
    this.working = true;
    /*
    if (event == 'ALL') {
      this.working = false;
      // this.ownerdisplayTx.setValue('');
      // this.ngOnInit();
      this.onChange.emit(undefined);
      return;
    }
    */
    let selectedOwner: any;
    let selectedOwnerId: string;
    if (this.owners !== undefined && event != null && event.trim() !== '') {
      const selectedOwners = this.owners.filter((item, index) => {
        if (item.ownerdisplayTx === event.trim()) {
          return true;
        }
      });
      if (selectedOwners.length > 0) {
        selectedOwner = selectedOwners[0];
        if (selectedOwner.ownerdisplayTx === 'ALL') selectedOwner.ownerId = undefined;
        sessionStorage.setItem('ownerResult', JSON.stringify(selectedOwner));
        selectedOwnerId = selectedOwner.ownerId;
      } else {
        selectedOwnerId = null;
      }
    } else {
      sessionStorage.removeItem('ownerResult');
      selectedOwnerId = undefined;
    }
    // try {
    //   this.onChange.emit(selectedOwnerId);
    // } catch (err) { }

    this.working = false;
  }

  clearOwner() {
    this.working = true;

    this.ownerdisplayTx.setValue('');

    sessionStorage.removeItem('ownerResult');
    const selectedOwnerId = undefined;

    try {
      this.onChange.emit(selectedOwnerId);
    } catch (err) { }
    this.working = false;
  }

  logout() {
    this.working = true;
    this.authLogoutService
      .post()
      .then(() => {
        sessionStorage.clear();
        this.router.navigate(['wa0001']);
        this.working = false;
        this.resetSingleOwner();
      })
      .catch(error => {
        sessionStorage.clear();
        this.router.navigate(['wa0001']);
        console.log(this.commonService.getErrorMessage(error));
        this.working = false;
      });
  }

  tochangepassword() {
    this.working = true;
    this.router.navigate(['wa9005']);
  }

  ngDoCheck() {
    const result = sessionStorage.getItem('loginResult');
    const loginResult = JSON.parse(result);
    this.isOperatorUser = loginResult.user.roleId === 2;
    this.displayedOwner = result !== null ? true : false;
    if(this.isOwnerlinkedUser) {
      this.showOwnerResetButton = 'none';
    } else this.showOwnerResetButton = '';

    if (this.displayedOwner) {
      this.isShowOwnerSelect = sessionStorage.getItem(this.STRINGS_IS_SHOW_OWNER_SELECT) != null;
    } else this.isShowOwnerSelect = false;

    if (this.isShowOwnerSelect) {
      this.isOwnerDisable = sessionStorage.getItem(this.STRINGS_IS_OWNER_DISABLE) != null;
      if (this.isOwnerDisable) this.ownerdisplayTx.disable();
      else this.ownerdisplayTx.enable();
    }
    //荷札出力画面の画面遷移防止
    if (this.router.url === '/wa3051?tab=0' || this.router.url === '/wa3051?tab=1') {
      this.showHumburgerMenu = false;
    }
    else{
      this.showHumburgerMenu = true;
    }  
  }

  /** Owner Start */
  ownerOnFocus() {
    if (this.isChooseOwner) {
      setTimeout(() => {
        this.isChooseOwner = false;
      }, 300);
      var inputDOM = this.ownerForm.nativeElement.querySelector('.headerInput');
      inputDOM.blur();
      this.isShowHeaderAutoloader = false;
      return;
    }

    this.filteredOwnerOptions = this.ownerdisplayTx.valueChanges.startWith(this.ownerdisplayTx.value).map(val => (this.ownerfilter2(val)));
    this.isShowHeaderAutoloader = true;
  }
  ownerOnBlur() {
    setTimeout(() => {
      this.isShowHeaderAutoloader = false;
    }, 200);
  }

  onHeaderAutoLoaderListClick(owner) {
    let val = owner.target.value;
    if (val.length == 0) return;
    var randomOwnerId = null;
    if (val.length > 0) {
      var result = this.ownerfilter3(val);
      if (result.length > 0)
        randomOwnerId = result[0]['ownerId'];
      if (randomOwnerId == null) {
        this.saveOwner(null);
        this.onInputChanged.emit(randomOwnerId);
        return;
      }
    }
    let selectOwner;
    for (let i = 0; i < this.owners.length; i++) {
      if (this.owners[i].ownerId === randomOwnerId)
        selectOwner = this.owners[i];
    }
    this.ownerdisplayTx.setValue(selectOwner.ownerdisplayTx);
    this.saveOwner(selectOwner.ownerdisplayTx);
    this.isChooseOwner = true;
    var inputDOM = this.ownerForm.nativeElement.querySelector('.headerInput');
    inputDOM.blur();
    this.isShowHeaderAutoloader = false;
  }

  onHeaderAutoloaderResetClick() {
    if (this.isOwnerDisable) return;
    this.clearOwner();
    this.ownerOnFocus();
  }

  onKeywordInput(e) {
    var val = e.target.value;

    var randomOwnerId = null;
    if (val.length > 0) {
      var result = this.ownerfilter3(val);
      if (result.length > 0) {
        randomOwnerId = result[0];
        if (randomOwnerId.ownerdisplayTx === 'ALL') randomOwnerId.ownerId = undefined;
        sessionStorage.setItem('ownerResult', JSON.stringify(randomOwnerId));
        randomOwnerId = randomOwnerId.ownerId;
      } else {
        randomOwnerId = null;
      }
    }
    if (randomOwnerId == null)
      sessionStorage.removeItem('ownerResult');
    this.onInputChanged.emit(randomOwnerId);
  }
  /**Owner End */

  openWa3051 () {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/wa3051'], {
        queryParams: {
          tab: 0
        }
      })
    );
    window.open(url, '_blank');
  }


  // 荷主ユーザの場合、荷主プルダウンで紐づき荷主を選択し、変更不可とする
  setLinkedowner () {
    const loginResult = JSON.parse(sessionStorage.getItem('loginResult'));
    if (loginResult.user.roleId != '3') {
      this.isOwnerlinkedUser = null;
      this.showCommonHeader = true; // 荷主ユーザ以外の共通ヘッダを表示
      return;
    } else {
      this.isOwnerlinkedUser = 'disabled';
      var linkedownerId = loginResult.user.linkedownerId;
      if (linkedownerId == null) {
        this.systemerr = '荷主との紐づけがされていない荷主ユーザです。';
        this.logout();
      }
      let selectOwner;
      for (let i = 0; i < this.owners.length; i++) {
        if (this.owners[i].ownerId === linkedownerId)
          selectOwner = this.owners[i];
      }
      if (selectOwner ==null) {
        this.systemerr = 'ユーザに紐づけられた荷主IDが不正です。';
        this.logout();
      }
      this.ownerdisplayTx.setValue(selectOwner.ownerdisplayTx);
      this.saveOwner(selectOwner.ownerdisplayTx);
      this.isChooseOwner = true;
      this.isShowHeaderAutoloader = false;
      this.showOwnerLinkedUserHeader = true;　// 荷主ユーザ専用のヘッダを表示
    }
  }

  setSingleOwner = (owners) => {
    if (Object.keys(owners).length === 1) {
      isSingleOwner = true;
      this.owner = owners[0];
      this.ownerdisplayTx.setValue(this.owner.ownerdisplayTx);
      this.saveOwner(this.owner.ownerdisplayTx);
      this.isChooseOwner = true;
      this.isShowHeaderAutoloader = false;
    } else {
      isSingleOwner = false;
    }
  };

  resetSingleOwner() {
    isSingleOwner = false;
  }
  
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/menu/header/header.component.ts